import React from 'react';
import {ShowIf} from 'components/utils';
import {Products} from 'api';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';

class FavoriteButton extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      averageRatingPoint: this.props.averageRatingPoint && this.props.averageRatingPoint.toFixed(1),
      totalRatingTimes: this.props.totalRatingTimes
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.averageRatingPoint !== this.props.averageRatingPoint || prevProps.totalRatingTimes !== this.props.totalRatingTimes) {
      this.setState({
        averageRatingPoint: this.props.averageRatingPoint.toFixed(1),
        totalRatingTimes: this.props.totalRatingTimes
      })
    }
  }

  rating(point) {
    Products.actions.rating.request({id: this.props.productId},{point}).then(res => {
      if (res.data) {
        toastr.success('Thành công!', `Bạn đã đánh giá sản phẩm này là ${point} sao.`);
        this.setState({
          averageRatingPoint: res.data.averageRatingPoint.toFixed(1),
          totalRatingTimes: res.data.totalRatingTimes
        })
      }
    })
  }

  checkUser() {
    if (this.props.user) {
      //do nothing
    } else {
      toastr.success('',`Vui lòng đăng nhập để thực hiện đánh giá sản phẩm`);
      this.props.history.push('/signin')
    }
  }

  render() {
    const {isFavorited, isLoading, averageRatingPoint, totalRatingTimes} = this.state;
    return (
      <div className="favorite-button">
        <div className='wrap-rating'>
          <p className='rating-text'>Đánh giá sản phẩm:</p>
          <div className='rating-result' onClick={this.checkUser.bind(this)}>
            <div className="rating-value" style={{width: averageRatingPoint * 20}}></div>
            <img src={require('assets/images/rating/result.png')} alt="rating" />
            <span className='rating-count'>{totalRatingTimes > 0 ? averageRatingPoint + '/5 (' + totalRatingTimes + ' đánh giá)' : 'Chưa có đánh giá nào'}</span>
          </div>
          {this.props.user ? (
            <div className='rating-item'>
              <div className='rating-point' style={{backgroundImage: `url(${require('assets/images/rating/star.png')})`}} onClick={this.rating.bind(this, 5)}></div>
              <div className='rating-point' style={{backgroundImage: `url(${require('assets/images/rating/star.png')})`}} onClick={this.rating.bind(this, 4)}></div>
              <div className='rating-point' style={{backgroundImage: `url(${require('assets/images/rating/star.png')})`}} onClick={this.rating.bind(this, 3)}></div>
              <div className='rating-point' style={{backgroundImage: `url(${require('assets/images/rating/star.png')})`}} onClick={this.rating.bind(this, 2)}></div>
              <div className='rating-point' style={{backgroundImage: `url(${require('assets/images/rating/star.png')})`}} onClick={this.rating.bind(this, 1)}></div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProp = (state) => {
  return {
    user: state.auth.user
  };
};

export default connect(mapStateToProp)(withRouter(FavoriteButton));



// WEBPACK FOOTER //
// ./components/partials/favorite-button/favorite-button.jsx